import { render, staticRenderFns } from "./activity-form-measurements-preview.vue?vue&type=template&id=324dc8cf&scoped=true&"
import script from "./activity-form-measurements-preview.vue?vue&type=script&lang=js&"
export * from "./activity-form-measurements-preview.vue?vue&type=script&lang=js&"
import style0 from "./activity-form-measurements-preview.vue?vue&type=style&index=0&id=324dc8cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324dc8cf",
  null
  
)

component.options.__file = "activity-form-measurements-preview.vue"
export default component.exports